var _circle, _circle2, _text, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGenericCryptoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Crypto") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#8A93A6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 4.2,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 0.9
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 8,
    y: 8.4,
    textAnchor: "middle",
    dominantBaseline: "central",
    fontFamily: "Arial, sans-serif",
    fontWeight: 700,
    fontSize: 5.6,
    fill: "#FFFFFF"
  }, "?")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.85,
    fill: "none",
    stroke: "#000",
    strokeOpacity: 0.12,
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenericCryptoCircle);
export default __webpack_public_path__ + "static/media/generic-crypto-circle.611e9be0b48d58b447cd7cc234f3fce5.svg";
export { ForwardRef as ReactComponent };